import { render, staticRenderFns } from "./CriterionSectionValueEditor.vue?vue&type=template&id=ef436ec6"
import script from "./CriterionSectionValueEditor.vue?vue&type=script&lang=ts"
export * from "./CriterionSectionValueEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports